import React, { useState } from 'react';
import { getDomainDebugInfo, detectDomain } from '../utils/domain';

const DomainDebugPanel = () => {
  const [showDebug, setShowDebug] = useState(false);
  const debugInfo = getDomainDebugInfo();
  const domain = detectDomain();

  // Only show in development
  if (!domain.isDev) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setShowDebug(!showDebug)}
        className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-lg text-xs font-mono shadow-lg"
      >
        Domain: {domain.isMycal ? 'MyCal' : 'DoubleMe'}
      </button>
      
      {showDebug && (
        <div className="absolute bottom-12 right-0 bg-white border-2 border-gray-300 rounded-lg p-4 shadow-xl max-w-md text-xs font-mono">
          <div className="mb-2 font-bold">Domain Debug Info</div>
          <pre className="whitespace-pre-wrap overflow-auto max-h-64">
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
          
          <div className="mt-4 pt-2 border-t border-gray-200">
            <div className="text-gray-600 mb-2">Test URLs:</div>
            <div className="space-y-1 text-xs">
              <div>MyCal: <code>?domain=mycal</code></div>
              <div>DoubleMe: <code>?domain=doubleme</code></div>
              <div>Port 5174: MyCal mode</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DomainDebugPanel;